module.exports = __webpack_public_path__ + "static/media/security.8c24a8df.jpg";